var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFitnessTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.7,
    height: 11.568,
    viewBox: "0 0 18.7 11.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fitness_TV",
    "data-name": "Fitness TV",
    transform: "translate(1126.947 -1555.439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4270",
    "data-name": "Rectangle 4270",
    d: "M.943-.5h.34A1.445,1.445,0,0,1,2.726.943V8.925a1.445,1.445,0,0,1-1.443,1.443H.943A1.445,1.445,0,0,1-.5,8.925V.943A1.445,1.445,0,0,1,.943-.5Zm.34,10.7A1.275,1.275,0,0,0,2.557,8.925V.943A1.275,1.275,0,0,0,1.283-.33H.943A1.275,1.275,0,0,0-.33.943V8.925A1.275,1.275,0,0,0,.943,10.2Z",
    transform: "translate(-1122.531 1556.289)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4271",
    "data-name": "Rectangle 4271",
    d: "M.943-.5h.17A1.445,1.445,0,0,1,2.557.943V8.925a1.445,1.445,0,0,1-1.443,1.443H.943A1.445,1.445,0,0,1-.5,8.925V.943A1.445,1.445,0,0,1,.943-.5Zm.17,10.7A1.275,1.275,0,0,0,2.387,8.925V.943A1.275,1.275,0,0,0,1.113-.33H.943A1.275,1.275,0,0,0-.33.943V8.925A1.275,1.275,0,0,0,.943,10.2Z",
    transform: "translate(-1114.72 1556.289)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9006",
    "data-name": "Path 9006",
    d: "M201.363,86.783h-1.778a.085.085,0,1,1,0-.17h1.778a.508.508,0,0,0,.508-.508V80.178a.508.508,0,0,0-.508-.508h-1.778a.085.085,0,1,1,0-.17h1.778a.678.678,0,0,1,.678.678v5.928A.678.678,0,0,1,201.363,86.783Z",
    transform: "translate(-1311.786 1478.141)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9007",
    "data-name": "Path 9007",
    d: "M25.72,86.783H24.113a.648.648,0,0,1-.613-.678V80.178a.648.648,0,0,1,.613-.678H25.72a.085.085,0,0,1,0,.17H24.113a.486.486,0,0,0-.459.508v5.928a.486.486,0,0,0,.459.508H25.72a.085.085,0,0,1,0,.17Z",
    transform: "translate(-1148.828 1478.141)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_24",
    "data-name": "Line 24",
    d: "M4.34-.33H-.415A.085.085,0,0,1-.5-.415.085.085,0,0,1-.415-.5H4.34a.085.085,0,0,1,.085.085A.085.085,0,0,1,4.34-.33Z",
    transform: "translate(-1119.474 1561.723)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_25",
    "data-name": "Line 25",
    d: "M.774-.33H-.415A.085.085,0,0,1-.5-.415.085.085,0,0,1-.415-.5H.774a.085.085,0,0,1,.085.085A.085.085,0,0,1,.774-.33Z",
    transform: "translate(-1109.455 1561.723)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_26",
    "data-name": "Line 26",
    d: "M.774-.33H-.415A.085.085,0,0,1-.5-.415.085.085,0,0,1-.415-.5H.774a.085.085,0,0,1,.085.085A.085.085,0,0,1,.774-.33Z",
    transform: "translate(-1126.097 1561.723)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitnessTv);
export default __webpack_public_path__ + "static/media/Fitness-TV.80d37c0ca88e3c9a2830bedd280b48e1.svg";
export { ForwardRef as ReactComponent };